import React from 'react';
import './HeroHeader.less';

const HeroHeader = (props) => {
    const {title, content, renderedCrumbs, metaDescription} = props;

    return (
        <section className="HeroHeader hub-section">
            <div className="HeroHeader__heading">
                <h1 itemProp="headline">{title}</h1>
                {renderedCrumbs}
            </div>
            <meta itemProp="description" content={metaDescription} />
            <p className="HeroHeader__description">{content}</p>
        </section>
    );
};

export default HeroHeader;
